module.exports = __webpack_public_path__ + "static/flags/LU-703965fd4af36ad83145db9c7d51c16c.gif";